import VueI18n from 'vue-i18n'
import langs from './langs'
import Vue from 'vue'

Vue.use(VueI18n)
const i18n = new VueI18n(langs)

export default i18n
